<template>
  <div class="">
    <i class="bi bi-plus-circle-fill h6" data-toggle="modal" data-target="#create-new-route"></i>

    <div class="modal fade" id="create-new-route" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class=" text-left  ">Modal title</h5>
          </div>

          <form @submit.prevent="createNewRoute">


            <div class="modal-body">
              <div class="form-group">
                <label for="form-name">نام</label>
                <input v-model="form.name" dir="ltr" required type="text" class="form-control text-left" id="form-name"
                       pattern="^[A-Za-z0-9]+$">
                <small id="form-name-description" class="form-text text-muted">example: LandingPage</small>
              </div>

              <div class="form-group">
                <label for="form-path">path</label>
                <input v-model="form.path" dir="ltr" required type="text" class="form-control text-left" id="form-path"
                       pattern="^\/[^ ]+$">
                <small id="form-name-description" class="form-text text-muted">example: /landing-page/65</small>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Create</button>
            </div>
          </form>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findCustomRoutes, flatRouter} from "@/store/Modules/Site";
import {siteRoutes} from '@moeinmdn/miw-router/src/package/routes/SiteRoutes'

export default {
  name: "CreateRouter",
  data() {
    return {
      siteRoutes,
      form: {
        name: "",
        path: "",
      }
    }
  },
  computed: {
    ...mapGetters({
      getSite: "Site/getSite",
      getSiteSelectedLanguage: "Site/getSiteSelectedLanguage",
      getSiteSelectedPage: "Site/getSiteSelectedPage",
      getPanels: 'Language/getPanels',
    }),
    selectedLanguagePages() {
      return this.getSite[this.getSiteSelectedLanguage]
    }
  },
  methods: {
    flatRouter,
    findCustomRoutes,
    createNewRoute() {
      let result = true;

      this.flatRouter(this.siteRoutes).forEach(item => {
        if (item.path == this.form.path || item.name == this.form.name) {
          result = false
        }
      })

      let currentPageRoutes = this.getSite[this.getSiteSelectedLanguage]['pages']
      let findCustomRoutes = this.findCustomRoutes(currentPageRoutes);
      findCustomRoutes.forEach(item => {
        if (item.path == this.form.path || item.name == this.form.name) {
          result = false
        }
      })

      if (result) {
        let languagePages = this.selectedLanguagePages['pages']
        languagePages[this.form.name] = {
          components: [],
          routeConfig: {
            panels: ['*'],
            routePath: this.form.path
          },
        }
        toast('صفحه با موفقیت ساخته شد', 'صفحه با موفقیت ساخته شد')
      } else {
        toast('نام یا path انتخابی موجود است', 'نام یا path انتخابی موجود است', 'danger')
      }

    }
  }
}
</script>


<style scoped>

</style>